import { render } from "./ManageAccountSettings.vue?vue&type=template&id=0a82a266&lang=pug"
import script from "./ManageAccountSettings.vue?vue&type=script&lang=js"
export * from "./ManageAccountSettings.vue?vue&type=script&lang=js"

import exportComponent from "/Users/redbot/nodeApps/thinkhub-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__